/* eslint-disable import/no-unresolved */
const $ = require('jquery');

window.jQuery = $;
window.$ = $;

require('bootstrap/dist/js/bootstrap.bundle');
require('base/components/spinner');
require('slick-carousel');

const processInclude = require('base/util');
const lozad = require('lozad');
const baseMenu = require('onestic-base/components/menu');
const baseCookie = require('base/components/cookie');
const baseCollapsibleItem = require('base/components/collapsibleItem');
const baseCountrySelector = require('base/components/countrySelector');
const baseSearch = require('onestic-base/components/search');
const miniCart = require('onestic-base/components/miniCart');
const toggleSwitch = require('onestic-base/components/ToggleSwitch');
const collapsible = require('onestic-base/components/collapsible');
const tooltip = require('onestic-base/components/Tooltip');
const login = require('onestic-base/login');
const header = require('onestic-base/components/header/header');
const headerMenu = require('onestic-base/components/header/headerMenu');
const backToTop = require('onestic-base/components/backToTop');
const breadcrumbs = require('onestic-base/components/breadcrumbs');
const baseClientSideValidation = require('onestic-base/components/clientSideValidation');
const consentTracking = require('onestic-base/components/consentTracking');
const pickupModal = require('onestic-base/components/pickupModal');
const form = require('onestic-base/components/form');
const domObserver = require('onestic-base/components/domObserver');
const extendQuantity = require('onestic-base/components/extendQuantity');
const searchAutoComplete = require('onestic-base/components/searchAutocomplete');
const headerInfoSlick = require('onestic-base/components/headerInfoSlick');
const wishlistHeart = require('onestic-base/product/wishlistHeart');
const extendStates = require('onestic-base/components/extendStates');
const newsletter = require('onestic-base/components/newsletter');
const account = require('onestic-base/components/account');
const warnings = require('onestic-base/components/warnings');
const footer = require('sesderma/components/footer');
const preHome = require('sesderma/components/preHome');
const newsletterPopup = require('sesderma/components/newsletterPopup');

$(document).ready(() => {
    processInclude(preHome);
    processInclude(lozad);
    processInclude(header);
    processInclude(headerMenu);
    processInclude(breadcrumbs);
    processInclude(backToTop);
    processInclude(login);
    processInclude(pickupModal);
    processInclude(consentTracking);
    processInclude(baseMenu);
    processInclude(baseCookie);
    processInclude(footer);
    processInclude(miniCart);
    processInclude(toggleSwitch);
    processInclude(collapsible);
    processInclude(tooltip);
    processInclude(baseCollapsibleItem);
    processInclude(baseSearch);
    processInclude(baseClientSideValidation);
    processInclude(baseCountrySelector);
    processInclude(form);
    processInclude(domObserver);
    processInclude(extendQuantity);
    processInclude(searchAutoComplete);
    processInclude(headerInfoSlick);
    processInclude(wishlistHeart);
    processInclude(extendStates);
    processInclude(newsletter);
    processInclude(account);
    processInclude(warnings);
    processInclude(newsletterPopup);
});
